<div class="title">
    {{ "widget_product_settings_typography" | translate | uppercase }}
</div>

<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-12">{{ "control_title_label" | translate }}</label>
        <div class="col-xs-4">
            <sp-input-num
                suffixText="px"
                [min]="FONT_SIZE_MIN"
                [max]="FONT_SIZE_MAX"
                [onlyIntegers]="true"
                [value]="titleSettingsFormGroup.controls.fontSize.value"
                (valueChange)="setFontSize(settingsType.title, $event)"
            ></sp-input-num>
        </div>
        <div class="col-xs-6 mb-10">
            <div class="btn-group btn-group-justified" data-toggle="buttons">
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.title, EFontStyle.AT)"
                    (click)="toggleActiveTextStyle(settingsType.title, EFontStyle.AT)"
                >
                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.title, EFontStyle.B)"
                    (click)="toggleActiveTextStyle(settingsType.title, EFontStyle.B)"
                >
                    <img src="./assets/img/lpc-icon-bold.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.title, EFontStyle.I)"
                    (click)="toggleActiveTextStyle(settingsType.title, EFontStyle.I)"
                >
                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                </label>
            </div>
        </div>
        <div class="col-xs-2">
            <sp-color-picker
                [hideGradient]="true"
                [colorsPreset]="selectedThemeColors()"
                [color]="titleSettingsFormGroup.controls.color.value"
                (colorChangeEvent)="setTextColor(settingsType.title, $event)"
            >
            </sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-12">{{ "control_description_label" | translate }}</label>
        <div class="col-xs-4">
            <sp-input-num
                suffixText="px"
                [min]="FONT_SIZE_MIN"
                [max]="FONT_SIZE_MAX"
                [onlyIntegers]="true"
                [value]="counterSettingsFormGroup.controls.fontSize.value"
                (valueChange)="setFontSize(settingsType.counter, $event)"
            ></sp-input-num>
        </div>
        <div class="col-xs-6 mb-10">
            <div class="btn-group btn-group-justified" data-toggle="buttons">
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.counter, EFontStyle.AT)"
                    (click)="toggleActiveTextStyle(settingsType.counter, EFontStyle.AT)"
                >
                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.counter, EFontStyle.B)"
                    (click)="toggleActiveTextStyle(settingsType.counter, EFontStyle.B)"
                >
                    <img src="./assets/img/lpc-icon-bold.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.counter, EFontStyle.I)"
                    (click)="toggleActiveTextStyle(settingsType.counter, EFontStyle.I)"
                >
                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                </label>
            </div>
        </div>
        <div class="col-xs-2">
            <sp-color-picker
                hideGradient
                [colorsPreset]="selectedThemeColors()"
                [color]="counterSettingsFormGroup.controls.color.value"
                (colorChangeEvent)="setTextColor(settingsType.counter, $event)"
            >
            </sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">{{ "control_price_label" | translate }}</label>
        <div class="col-xs-3 text-right">
            <sp-switch
                [active]="priceSettingsFormGroup.controls.isShow.value"
                (toggleActiveEvent)="setIsShowText(settingsType.price, $event)"
            ></sp-switch>
        </div>
        <div class="col-xs-4">
            <sp-input-num
                suffixText="px"
                [min]="FONT_SIZE_MIN"
                [max]="FONT_SIZE_MAX"
                [onlyIntegers]="true"
                [value]="priceSettingsFormGroup.controls.fontSize.value"
                (valueChange)="setFontSize(settingsType.price, $event)"
            ></sp-input-num>
        </div>
        <div class="col-xs-6 mb-10">
            <div class="btn-group btn-group-justified" data-toggle="buttons">
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.price, EFontStyle.AT)"
                    (click)="toggleActiveTextStyle(settingsType.price, EFontStyle.AT)"
                >
                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.price, EFontStyle.B)"
                    (click)="toggleActiveTextStyle(settingsType.price, EFontStyle.B)"
                >
                    <img src="./assets/img/lpc-icon-bold.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.price, EFontStyle.I)"
                    (click)="toggleActiveTextStyle(settingsType.price, EFontStyle.I)"
                >
                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                </label>
            </div>
        </div>
        <div class="col-xs-2">
            <sp-color-picker
                [hideGradient]="true"
                [colorsPreset]="selectedThemeColors()"
                [color]="priceSettingsFormGroup.controls.color.value"
                (colorChangeEvent)="setTextColor(settingsType.price, $event)"
            >
            </sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-0">
        <label class="col-xs-9 control-label">{{ "control_price_old_label" | translate }}</label>
        <div class="col-xs-3 text-right">
            <sp-switch
                [active]="oldPriceSettingsFormGroup.controls.isShow.value"
                (toggleActiveEvent)="setIsShowText(settingsType.oldPrice, $event)"
            ></sp-switch>
        </div>
        <div class="col-xs-4">
            <sp-input-num
                suffixText="px"
                [min]="FONT_SIZE_MIN"
                [max]="FONT_SIZE_MAX"
                [onlyIntegers]="true"
                [value]="oldPriceSettingsFormGroup.controls.fontSize.value"
                (valueChange)="setFontSize(settingsType.oldPrice, $event)"
            ></sp-input-num>
        </div>
        <div class="col-xs-6 mb-10">
            <div class="btn-group btn-group-justified" data-toggle="buttons">
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.oldPrice, EFontStyle.AT)"
                    (click)="toggleActiveTextStyle(settingsType.oldPrice, EFontStyle.AT)"
                >
                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.oldPrice, EFontStyle.B)"
                    (click)="toggleActiveTextStyle(settingsType.oldPrice, EFontStyle.B)"
                >
                    <img src="./assets/img/lpc-icon-bold.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.oldPrice, EFontStyle.I)"
                    (click)="toggleActiveTextStyle(settingsType.oldPrice, EFontStyle.I)"
                >
                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                </label>
            </div>
        </div>
        <div class="col-xs-2">
            <sp-color-picker
                [hideGradient]="true"
                [colorsPreset]="selectedThemeColors()"
                [color]="oldPriceSettingsFormGroup.controls.color.value"
                (colorChangeEvent)="setTextColor(settingsType.oldPrice, $event)"
            >
            </sp-color-picker>
        </div>
    </div>
</div>
